var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInvoice = function SvgInvoice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39844 4.00006C1.39844 2.19593 2.86097 0.733398 4.6651 0.733398H11.3318C13.1359 0.733398 14.5984 2.19593 14.5984 4.00006V12.0001C14.5984 13.8042 13.1359 15.2667 11.3318 15.2667H4.6651C2.86097 15.2667 1.39844 13.8042 1.39844 12.0001V4.00006ZM4.6651 1.9334C3.52372 1.9334 2.59844 2.85868 2.59844 4.00006V12.0001C2.59844 13.1415 3.52372 14.0667 4.6651 14.0667H11.3318C12.4732 14.0667 13.3984 13.1415 13.3984 12.0001V4.00006C13.3984 2.85868 12.4732 1.9334 11.3318 1.9334H4.6651Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0651 4.66673C4.0651 4.33536 4.33373 4.06673 4.6651 4.06673L11.3318 4.06673C11.6631 4.06673 11.9318 4.33536 11.9318 4.66673C11.9318 4.9981 11.6631 5.26673 11.3318 5.26673L4.6651 5.26673C4.33373 5.26673 4.0651 4.9981 4.0651 4.66673Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0651 8.00006C4.0651 7.66869 4.33373 7.40006 4.6651 7.40006L11.3318 7.40007C11.6631 7.40007 11.9318 7.66869 11.9318 8.00006C11.9318 8.33144 11.6631 8.60007 11.3318 8.60007L4.6651 8.60006C4.33373 8.60006 4.0651 8.33144 4.0651 8.00006Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0651 11.3334C4.0651 11.002 4.33373 10.7334 4.6651 10.7334L7.99844 10.7334C8.32981 10.7334 8.59844 11.002 8.59844 11.3334C8.59844 11.6648 8.32981 11.9334 7.99844 11.9334L4.6651 11.9334C4.33373 11.9334 4.0651 11.6648 4.0651 11.3334Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInvoice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "invoice.f724ccd85403671862a01f777709304f.svg";